import type { ReactNode } from 'react'

import { SettingsFieldLabel } from '@/components/settings/settings-field-copy'
import { SettingsRowFrame } from '@/components/settings/settings-row-frame'
import { cn } from '@/lib/utils'

export type SettingsSectionHeadingProps = {
  children: ReactNode
  /** When false, adds an inset top border to separate from the prior section. */
  isFirst?: boolean
  className?: string
}

/** Group label inside a settings panel — muted band, inset borders matching row dividers. */
export function SettingsSectionHeading({
  children,
  isFirst = false,
  className,
}: SettingsSectionHeadingProps) {
  return (
    <SettingsRowFrame
      showDivider
      className={className}
      innerClassName={cn('bg-muted/30 py-2.5', !isFirst && 'border-t')}
    >
      <SettingsFieldLabel className="text-muted-foreground">{children}</SettingsFieldLabel>
    </SettingsRowFrame>
  )
}
